import { PageWrapper } from 'components/chatWidget/common/Elements';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getAccountInfo } from '../system/systemAction';
// import Footer from './containers/Footer';
import Header from './containers/Header';
import Home from './containers/Home';

const Layout = (props) => {
  return (
    <PageWrapper>
      <Header />
      <Home />
      {/* <Footer /> */}
    </PageWrapper>
  );
};
export default connect(
  (state) => ({
    // isLoading: state.system.isLoading
  }),
  { getAccountInfo }
)(withRouter(Layout));
